import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { EMPTY } from 'rxjs';

import { CustomerOnboardingContextService } from '../services/customer-onboarding-context.service';

/**
 * Ensures customer onboarding context is loaded before route activation.
 */
export const customerOnboardingContextResolver: ResolveFn<unknown> = (route) => {
  const customerId: string | null = route.paramMap.get('customerId');
  const customerOnboardingContextService = inject(CustomerOnboardingContextService);

  if (!customerId) {
    return EMPTY;
  }

  return customerOnboardingContextService.ensureLoaded$(customerId);
};
